import { Box, Grid, Typography } from '@mui/material';
import { VaultTvl } from './components/VaultTvl';
import { UserAssetsInVault } from './components/UserAssetsInVault';
import { useBreakpoints } from 'modules/common/hooks/useBreakpoints';

export function Stats(): JSX.Element {
  const { isSmDown } = useBreakpoints();

  return (
    <Box mt={isSmDown ? 3 : 8}>
      <Typography variant="subtitle1" fontWeight={500}>
        Stats
      </Typography>
      <Grid
        container
        spacing={isSmDown ? 1.5 : 4}
        justifyContent="center"
        mt={isSmDown ? 0.5 : -2}
      >
        <VaultTvl />
        <UserAssetsInVault />
      </Grid>
    </Box>
  );
}
